'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import MaterialDialogTitle from '@mui/material/DialogTitle';
import { IconButton } from '../IconButton/IconButton';
import { Divider } from '../Divider';
import { Box } from '../Box';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { useModalContext } from './ModalContext';
const StyledCloseButton = styled(IconButton)({
    marginLeft: 'auto',
    marginRight: '-.75rem'
});
const StyledModalTitle = styled(MaterialDialogTitle)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.tokens.FuelSpacing1,
    fontSize: theme.tokens.FuelFontSizeXl,
    lineHeight: theme.tokens.FuelLineHeightXl
}));
export const ModalTitle = React.forwardRef(({ children, divider = false, ...props }, ref) => {
    const { onClose, showClose } = useModalContext();
    return (_jsxs(_Fragment, { children: [_jsxs(StyledModalTitle, { ref: ref, ...props, children: [children, showClose ? (_jsx(StyledCloseButton, { "aria-label": 'close', onClick: onClose, size: 'large', children: _jsx(CloseIcon, {}) })) : null] }), divider &&
                _jsx(Box, { mb: 2, children: _jsx(Divider, {}) })] }));
});
ModalTitle.displayName = 'ModalTitle';
